// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"12acbd68","395":"ee1560e7","427":"fc6d7aa7","851":"bb681984","940":"bc09708b"}[chunkId] + ".css";
};